export enum GroupLandingCTAType {
  EVERYONE_UNLIMITED = 'EVERYONE_UNLIMITED',
  MIX_AND_MATCH = 'MIX_AND_MATCH',
}

export interface GroupLandingPageCTAProps {
  buttonType: GroupLandingCTAType
  dataTestIdPrefix?: string
  onClick?: () => void
}
